export default __webpack_public_path__ + "static/media/editIcon.ef3fc783.svg";